import React from 'react'

const Container = ({ children }) => {
  return (
    <div className="bg-[#131517] min-h-screen overflow-clip w-full font-dm pt-[116px] sm:pt-28 px-4 relative">
      <div className="max-w-[1440px] mx-auto">{children}</div>
    </div>
  )
}

export default Container
